import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

//components
import { NewBackButton } from "../../../components/svgs";
import { StyledText } from "../../../components/common/basic";

// theme
import { useTheme, useTrivia } from "../../../hooks";
import { Desktop } from "../../../containers/common";
import PlayTriviaModal from "./PlayTriviaModal";
import TriviaInfoModal from "./TriviInfoModal";
import { OfferAlertModal } from "../../../components/loyalty";

const TriviaPage = () => {
  const [showModalUnavailable, setModalUnavailable] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [unavailableMsg, setModalUnavailableMsg] = useState();
  const [showModalQualified, setModalQualified] = useState(false);
  const [modalQualifiedMessage, setModalQualifiedMessage] = useState("");

  const { activeTriviaCategory, activeTrivia, setActiveTrivia, activeRewardScheme, setActiveRewardScheme } = useTrivia();
  const { name, trivia, isMultiTrivia } = activeTriviaCategory || {};
  const [playTriviaModal, setPlayTriviaModal] = useState(false);
  const [triviInfoModal, setTriviaInfoModal] = useState(false);
  const { themeContext, theme } = useTheme();

  let history = useHistory();

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  const themeColor = theme.colors[themeContext.activeTheme]["background"];

  if (!isMultiTrivia) {
    // Perform non multi trivia action
  }
  const msg = {
    unplayable: "Sorry, this trivia is only available during the event period.",
    exhaustedAttempts: "You have exhausted your number of tries for this trivia and can no longer play.",
  }

  const handleTriviaSelect = (triv) => {
    const {
      maxAttempts,
      canStartPlay,
      isClosed,
      rewardScheme,
      userStats
    } = triv;
    const { attempts, hasWon, wonData } = userStats || {};
    if (hasWon) {
      const { referenceCode, hasRedeemed } = wonData;
      const message = referenceCode ? triv?.wonRewardMessage : triv?.wonNoRewardMessage;
      if (referenceCode) {
        setActiveRewardScheme(rewardScheme);
      }
      setModalQualified(true);
      setModalQualifiedMessage(hasRedeemed ? "You have already claimed your reward!" : message)
      setActiveTrivia(triv);
    } else if (attempts >= maxAttempts) {
      setModalUnavailableMsg(msg.exhaustedAttempts)
      setModalUnavailable(true);
    }
    // else if (isClosed) {
    //   setModalUnavailableMsg(msg.unplayable)
    //   setModalUnavailable(true);
    // }
    else if (!canStartPlay) {
      setModalUnavailableMsg(msg.unplayable)
      setModalUnavailable(true);

    } else {
      setActiveTrivia(triv);
      setActiveRewardScheme(triv?.rewardScheme)
      if (triv?.requireIdentification) {
        history.push('/trivia/identification')
      } else {
        history.push('/trivia/region')
      }
    }
  }

  return (
    <>
      <MainHolder>
        <Children>
          <div
            style={{
              width: "55%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position:'fixed'
            }}
          >
            <BackButtonContainer
              onClick={() => {
                history.push('/trivia/trivia-category');
              }}
              style={{ zIndex: 100, marginLeft: 20 }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <StyledText>{name}</StyledText>
          </div>
          <DescriptionBody color={mashupBackground}>
            <HistoryContainer>
              {trivia && trivia.map((triv) => (
                <div
                  onClick={() => handleTriviaSelect(triv)}
                  style={{
                    backgroundColor: triv?.color || "black",
                    borderRadius: 15,
                    padding: 5,
                    marginBottom: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      height: 61,
                      justifyContent: "center",
                    }}
                  >
                    {false && (
                      <StyledText style={{ marginLeft: 30, fontSize: 40 }}>
                        {triv?.emoji}
                      </StyledText>
                    )}
                    <div>
                      <StyledText color="white" style={{ fontSize: 15 }}>
                        {triv?.title}
                      </StyledText>
                    </div>
                  </div>
                  {/* <div
                    style={{
                      marginTop: name === "Festival Trivia" ? -30 : 0,
                    }}
                  >
                    {name === "Festival Trivia" && (
                      <StyledText
                        color="white"
                        style={{ fontSize: 12, fontFamily: "MTNRegular" }}
                      >
                        {triv?.canStartPlay ? "Happening now" : "Happening later"}
                      </StyledText>
                    )}
                  </div> */}
                  <div style={{
                    marginTop: -30,
                  }}
                  >
                    <StyledText
                      color="white"
                      style={{ fontSize: 12, fontFamily: "MTNRegular" }}
                    >
                      {!triv?.canStartPlay ? "Happening later" : (triv?.rewardScheme !== "online" ? "Exclusive to on-ground attendees." : "Happening now")}
                    </StyledText>

                  </div>
                </div>
              ))}
            </HistoryContainer>
          </DescriptionBody>
        </Children>
      </MainHolder>
      {playTriviaModal && (
        <PlayTriviaModal onBackDropClick={() => setPlayTriviaModal(false)} />
      )
      }
      {
        triviInfoModal && (
          <TriviaInfoModal onBackButtonClick={() => setTriviaInfoModal(false)} />
        )
      }
      {
        showModalUnavailable && (
          <OfferAlertModal
            background={themeColor}
            hideModal={() => {
              setModalUnavailable(false);
              // history.push(`/trivia/trivia-category`)
            }}
            title='Trivia not available'
            description={unavailableMsg}
          />
        )
      }
      {
        showModalQualified && (
          <OfferAlertModal
            background={themeColor}
            hideModal={() => {
              setModalQualified(false)
              const { userStats: { wonData: { voucher } }, availableRewardTypes } = activeTrivia
              if (activeRewardScheme === "online" || availableRewardTypes.length) {
                if (voucher && voucher != "airtime") {
                  history.push(`/trivia/order_details`)
                } else {
                  // Check if reward types are listed
                  if (availableRewardTypes?.length) {
                    history.push(`/trivia/pick`);
                  }
                }
              } else {
                history.push(`/trivia/redeem-onground`)
              }
            }}
            title={"Congratulations"}
            description={modalQualifiedMessage}
          />
        )
      }

    </>
  );
};


const MainHolder = styled.div`
  overflow: hidden;
  scrollbar-width: none;
  /* background-color: ${({ activeTheme }) => activeTheme}; */
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  //   position: absolute;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
`;

const ContentHolder = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: "5px";
`;
const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
const HistoryContainer = styled.div`
  width: 80%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
export default TriviaPage;
